<script setup lang="ts">
import { ref } from 'vue';
import { Field } from 'vee-validate';

// TODO improve this
const suffixes = ['Jr.', 'Sr.', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'];

const model = defineModel<string>();

const value = ref(model.value);

const emitChange = (event: Event): void => {
  const target = event.target as HTMLInputElement;
  model.value = target?.value;
};
</script>
<template>
  <Field v-model="value" @change="emitChange" v-slot="{ field, meta }" name="suffix">
    <select class="w-auto right" v-bind="field" :class="{ ...meta }">
      <option value="">Suffix</option>
      <option v-for="suffix in  suffixes" :value="suffix" :key="suffix">{{ suffix }}</option>
    </select>
  </Field>
</template>
